// removed by extract-text-webpack-plugin
module.exports = {"collapse-card":"collapse-card","card-title":"card-title","title-indicator":"title-indicator","title":"title","line":"line","card-body":"card-body","run-label":"run-label"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/BaseCollapse/index.scss
// module id = 1379
// module chunks = 0